import { Dish } from '../menu/dishs/data';
// import { tempData } from './components/TableOrder';

// export type Order = typeof tempData[0];

export enum ORDER_PROCESSING_STATUS {
  AWAITING_PAYMENT = 'awaiting_payment',
  SUBMIITTED = 'submitted',
  SHIPPER_OK = 'shipper_ok',
  RESTAURANT_OK = 'restaurant_ok',
  PICKED = 'picked',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  DECLINED = 'declined',
  REFUNDED = 'refunded',
  BOM = 'bom',
}
export type FoodOrderStateMerged = FoodOrder & {
  viewedDetail: boolean;
};
// export type OrderProcessingMerged = FoodOrderProcessing & {
//   viewedDetail: boolean;
// };
// export type FoodOrderProcessing = FoodOrder & {
//   status: ORDER_PROCESSING_STATUS;
// };
// export type Order = {
//   id: number;
//   code: string;
//   orderAt: Date;
//   orderDetail: {
//     items: OrderItem[];
//     promotions: Promotion[] | null;
//   };
//   shipper: OrderShipper | null;
// };
type OrderItem = {
  dish: Dish;
  price: Price;
  realPrice: Price;
  originalPrice: Price;
  quantity: number;
  totalAmount: Price;
};
type OrderShipper = {
  id: number;
  email: string;
  fullname: string;
  gender: number;
  isActive: boolean;
  latitude: number;
  longtitude: number;
  percentageDuration: 20;
  phone: string;
  phoneNumber: string;
  rating: 0;
  token: string;
};

type Price = {
  text: string;
  unit: string;
  value: number;
};
type CartItemOption = {
  id: number;
  name: string;
  quantity: number;
  price: Price;
};
type CartItemOptionGroup = {
  id: number;
  name: string;
  description: string;
  min: number;
  max: number;
  isRequired: boolean;
  options: CartItemOption[];
};

type ListFoodOrder = {
  id: number;
  code: string;
  orderAt: Date;
  shipper: OrderShipper | null;
  orderDetail: FoodOrderDetail;
};

// export type StatusOrdersHistory =
//   | 'picked'
//   | 'completed'
//   | 'cancelled'
//   | 'declined'
//   | 'refunded'
//   | 'bom';
// export type ListFooderOrderHistory = ListFoodOrder & {
//   status: StatusOrdersHistory;
// };

// export type StatusOrdersProcessing =
//   | 'awaiting_payment'
//   | 'submitted'
//   | 'shiper_ok'
//   | 'restaurant_ok'
//   | 'picked'
//   | 'completed'
//   | 'cancelled'
//   | 'declined'
//   | 'refunded'
//   | 'bom';
// export type ListFooderOrderProcessing = ListFoodOrder & {
//   status: StatusOrdersProcessing;
// };

export type FoodOrder = {
  id: number;
  code: string;
  // status: StatusOrdersHistory & StatusOrdersProcessing;
  orderAt: Date;
  orderNote: string;
  status: ORDER_STATUS;
  shipper: OrderShipper;
  totalItem: number;
  totalCount: number;

  orderValue: Price;
  totalDiscount: Price;
  totalAmount: Price;
  promotionCode: string[];
  orderDetail: OrderDetail;
};
export enum ORDER_STATUS {
  AWAITING_PAYMENT = 'awaiting_payment',
  BOM = 'bom',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  DECLINED = 'declined',
  PICKED = 'picked',
  REFUNDED = 'refunded',
  RESTAURANT_DECLINED = 'restaurant_declined',
  SHIPPER_DECLINED = 'shipper_declined',
  SHIPPER_OK = 'shipper_ok',
  SUBMIITTED = 'submitted',
}
type OrderDetail = {
  promotions: Promotion[];
  items: CartItem[];
};
type Promotion = {
  id: number;
  code: string;
  name: string;
  description: string;
  startsFrom: Date;
  endTill: Date;
  discountType: string;
  discountTarget: string;
};
type CartItem = {
  id: number;
  quantity: number;
  note: string;
  originalPrice: Price;
  price: Price;
  realPrice: Price;
  totalAmount: Price;
  dish: Dish;
  optionGroups: CartItemOptionGroup[];
};

export enum EVENT {
  CONNECT = 'connect',
  CONNECT_ERROR = 'connect_error',
  DISCONNECT = 'disconnect',
}

export type FoodOrderDetail = {
  id: number;
  code: string;
  status: ORDER_STATUS;
  orderAt: Date;
  orderNote: string | null;
  orderValue: Price;
  shipper: OrderShipper | null;
  deliveryTo: {
    id: number;
    address: string;
    name: string;
    phone: string;
  };
  orderDetail: OrderDetail;
  promotionCode: string | null;
  totalAmount: Price;
};
